import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import CurveLine from './curve-line.vue';
let default_1 = class default_1 extends Vue {
    // @Prop() readonly numData!: IUMC
    daySummary;
    get time() {
        const res = this.daySummary[0]?.averageTimePassQueueHistoryList || [];
        return res;
    }
    get averTime() {
        return (this.daySummary[0]?.averagePassTime || 0).toFixed(2) || 0;
    }
    mounted() {
    }
};
__decorate([
    Prop()
], default_1.prototype, "daySummary", void 0);
default_1 = __decorate([
    Component({
        name: 'ChartTime',
        components: { 'curve-line': CurveLine },
        i18n: {
            messages: {
                'en-us': {
                    averageTime: 'Average Queuing Time (Today）',
                    people: 'min'
                },
                zh: {
                    averageTime: '平均排队时长(今日)',
                    people: '分'
                },
            },
        }
    })
], default_1);
export default default_1;
